export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "imgResizer": {
    "title": "图片尺寸调整器",
    "subtitle": "为社交媒体、演示文稿和网页调整图片尺寸。",
    "privacy": "100% 本地处理",
    "noUpload": "无需上传",
    "uploadTitle": "上传图片",
    "uploadDesc": "拖拽或点击选择。支持 JPEG、PNG、WebP。",
    "addFiles": "添加图片",
    "files": "文件",
    "preset": "预设尺寸",
    "width": "宽度",
    "height": "高度",
    "mode": "调整模式",
    "modeCover": "裁剪填充",
    "modeContain": "等比缩放",
    "modeStretch": "拉伸",
    "modeFill": "填充",
    "bgColor": "背景色",
    "processing": "正在处理...",
    "resize": "全部调整",
    "invalidFile": "请选择图片文件",
    "presetInstaPost": "Instagram 帖子",
    "presetInstaStory": "Instagram 快拍",
    "presetTwitterHeader": "Twitter/X 封面",
    "presetTwitterPost": "Twitter/X 帖子",
    "presetFacebookCover": "Facebook 封面",
    "presetFacebookPost": "Facebook 帖子",
    "presetYouTubeThumb": "YouTube 缩略图",
    "presetLinkedInBanner": "LinkedIn 横幅",
    "presetA4Portrait": "A4 竖版",
    "presetA4Landscape": "A4 横版",
    "presetHD": "高清 1080p",
    "presetCustom": "自定义"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有图片调整大小均在您的浏览器本地完成。您的图片绝不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用图片调整大小工具",
      "description": "使用精确的维度控制，调整图片大小以适应社交媒体、演示文稿和网页。",
      "steps": [
        {
          "title": "上传图片",
          "description": "拖放或点击选择图片文件。该工具支持 JPG、PNG、WebP 和 GIF 格式。"
        },
        {
          "title": "设置尺寸或预设",
          "description": "输入精确的宽度和高度（像素），或从热门预设中选择：Instagram、Twitter、Facebook、LinkedIn 或 HD 1080p。"
        },
        {
          "title": "下载调整后的图片",
          "description": "预览调整后的图片并点击下载保存。宽高比可以锁定或自由调整。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "精确的像素级尺寸控制",
        "内置热门社交媒体预设",
        "保持或覆盖宽高比",
        "下载前实时预览",
        "支持 JPG、PNG、WebP 和 GIF",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的图片会被发送到服务器吗？",
          "answer": "不会。所有调整大小均通过 HTML5 Canvas 在您的浏览器本地完成。您的图片绝不会被传输或存储到外部。"
        },
        {
          "question": "调整大小会降低图片质量吗？",
          "answer": "缩小尺寸通常能保持良好的质量。放大尺寸可能会根据算法产生一些像素化。为了获得最佳效果，请从可用的最高分辨率源图片开始。"
        },
        {
          "question": "可以一次调整多张图片的大小吗？",
          "answer": "目前该工具一次处理一张图片以实现精确控制。对于批量调整大小，请考虑使用我们的图片水印工具，它支持批量处理。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "图片转换器",
          "url": "/image/image-converter",
          "description": "在浏览器中即时转换 JPG、PNG 和 WebP 格式。"
        },
        {
          "name": "图片水印工具",
          "url": "/image/image-watermarker",
          "description": "为图片添加文本或 logo 水印，支持批量处理。"
        },
        {
          "name": "表情包生成器",
          "url": "/image/meme-generator",
          "description": "使用热门模板或您自己的图片即时创建表情包。"
        }
      ]
    }
  }
};
